export default {"src":"/_next/static/media/bluesky.851cefe8.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};